module.exports = __webpack_public_path__ + "img/ZoomGreen&Black.fb89a1a9.png";